"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _getLevelHelper = require("../../../helpers/getLevelHelper");
var _KYC_IMLegacyHelpers = require("../KYC_IMLegacyHelpers");
var _KYC_IMLegacyFormComponent = _interopRequireDefault(require("./KYC_IMLegacyFormComponent"));
var _kycLevelsSelectors = require("../../../redux/selectors/kycLevelsSelectors");
var _reduxForm = require("redux-form");
var _kycIdentityMindActions = require("../../../redux/actions/kycIdentityMindActions");
var _authActions = require("../../../redux/actions/authActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var _kycLevelFormSelector = (0, _kycLevelsSelectors.kycLevelFormSelector)(state),
    verificationLevel = _kycLevelFormSelector.verificationLevel,
    kycConfig = _kycLevelFormSelector.kycConfig,
    kyc = _kycLevelFormSelector.kyc,
    alphaPointSessiontoken = _kycLevelFormSelector.alphaPointSessiontoken,
    alphaPointUserID = _kycLevelFormSelector.alphaPointUserID,
    userConfig = _kycLevelFormSelector.userConfig,
    userName = _kycLevelFormSelector.userName,
    email = _kycLevelFormSelector.email,
    processing = _kycLevelFormSelector.processing,
    levelIncreaseStatus = _kycLevelFormSelector.levelIncreaseStatus;
  var level = (0, _getLevelHelper.getDisplayLevel)(kycConfig, (0, _KYC_IMLegacyHelpers.getCurrentLevel)(verificationLevel, levelIncreaseStatus));
  return {
    level: level,
    processing: processing,
    formValues: (0, _reduxForm.getFormValues)('KYCIMLegacyForm')(state),
    // Used in KYCMitekComponent
    alphaPointUserID: alphaPointUserID,
    alphaPointSessiontoken: alphaPointSessiontoken,
    kycConfig: kycConfig,
    userName: userName,
    kyc: kyc,
    userConfig: userConfig,
    // Submit IM helper
    email: email
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    // Used in KYCMitekComponent
    confirmInfoMitek: function confirmInfoMitek(setUserConfigPayload) {
      return dispatch((0, _kycIdentityMindActions.confirmMitek)(setUserConfigPayload));
    },
    launchMitek: function launchMitek(payload) {
      return dispatch((0, _kycIdentityMindActions.validateUserRegistrationMitek)(payload));
    },
    // Submit IM helper
    submitInfoIdentityMind: function submitInfoIdentityMind(payload) {
      return dispatch((0, _kycIdentityMindActions.validateUserRegistrationIdentityMind)(payload));
    },
    reset: function reset() {
      return dispatch((0, _reduxForm.reset)('KYCIMLegacyForm'));
    },
    logout: function logout() {
      return dispatch((0, _authActions.logout)());
    }
  };
};
var KYC_IMLegacyForm = (0, _reduxForm.reduxForm)({
  form: 'KYCIMLegacyForm',
  onSubmit: function onSubmit() {}
})(_KYC_IMLegacyFormComponent["default"]);
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(KYC_IMLegacyForm);